exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-chart-legend-item{display:block;color:#4a4a4a;font-size:14px;width:100%}adp-chart-legend-item .color-indicator{display:block;width:12px;height:12px;margin-right:8px;border-radius:2px;background-color:#53727f}adp-chart-legend-item .label{font-family:ProximaNova-Bold,Arial,Helvetica,sans-serif;display:inline-block}adp-chart-legend-item .value-percents{padding-right:4px;font-family:ProximaNova-Bold,Arial,Helvetica,sans-serif}adp-chart-legend-item .value-count{text-align:right}adp-chart-legend-item .value-count.bold{font-family:ProximaNova-Bold,Arial,Helvetica,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpChartLegendItem/adpChartLegendItem.less
// module id = 618
// module chunks = 0